import React from "react";
import { message } from "antd";
import MessagePopupError from "../ui/components/MessagePopupError";

const defaultHide = () => {
  message.destroy();
};

export const displayError = (resourceKey: string, translate = true) => {
  const hideRef = {
    hide: defaultHide
  };
  hideRef.hide = message.error({
    content: (
      <MessagePopupError
        messageText={resourceKey}
        hideRef={hideRef}
        translate={translate}
      />
    ),
    onClose: () => {
      hideRef.hide = defaultHide;
    },
    duration: 0
  });
};
